export type LegacyBulkProductRow = {
  id: number
  name: string
  cost: string
  price: string
  runtime: string
  minPhotos: string
  maxPhotos: string
  dpi: string
  minLong: string
  minShort: string
  replacements: string[]
  imageName: string
}

export const legacyBulkProductRows: LegacyBulkProductRow[] = [
  {
    id: 1,
    name: '',
    cost: '',
    price: '',
    runtime: '',
    minPhotos: '',
    maxPhotos: '',
    dpi: '',
    minLong: '',
    minShort: '',
    replacements: ['', '', '', '', ''],
    imageName: '',
  },
]

export const legacyBulkProductTypes = [
  { id: 2, name: '앨범' },
  { id: 3, name: '액자' },
  { id: 4, name: '기타상품' },
  { id: 5, name: '파일' },
  { id: 6, name: '메이크업' },
  { id: 7, name: '의상대여' },
]

export const legacyBulkCategories = [
  '- 필수선택 -',
  ...Array.from({ length: 13 }, (_, index) => `Mock 상품구분 ${String(index + 1).padStart(2, '0')}`),
  '직접입력',
]

export const legacyBulkStatistics = [
  'Select an Option',
  ...Array.from({ length: 7 }, (_, index) => `Mock 통계구분 ${String(index + 1).padStart(2, '0')}`),
  '직접입력',
]

export const legacyBulkVendors = [
  '- 필수선택 -',
  'Mock 제작업체 01',
  'Mock 제작업체 02',
]
